var modules_997b7aad = {"logoLink":"Logo_module_logoLink__a693d1e8","logo":"Logo_module_logo__a693d1e8"};
import "../../../assets/Dv0DaqZU.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
